export enum SwapStatus {
    PENDING=0,
    ACCEPTED,
    REJECTED
}